import { HStack, Text, VStack } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import Modal from "@/components/molecules/Modal";
import { formatToCurrency } from "@/utils/helpers";

import { ModalPropos } from "../types";

const OutdatedPromoPricesModal = ({
  isOpen,
  currentValue,
  newSubtotal,
  onClose,
  onSubmit,
}: ModalPropos<number> & { newSubtotal: number }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      Header="Atenção"
      Body={
        <VStack>
          <Text mb="4" textAlign="center">
            Alguns produtos adicionados ao Carrinho estão com valor promocional. No agendamento da
            compra para a data solicitada, haverá alteração no valor final do pedido conforme
            apresentado abaixo:
          </Text>
          <HStack justifyContent="space-between">
            <Text bold>Subtotal hoje:</Text>
            <Text color="primary.600" bold>
              {formatToCurrency(currentValue || 0)}
            </Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text bold>Subtotal na data agendada:</Text>
            <Text color="primary.600" bold>
              {formatToCurrency(newSubtotal)}
            </Text>
          </HStack>
          <Text my="2">Deseja continuar?</Text>
        </VStack>
      }
      Footer={
        <VStack w="full">
          <FormButton mt="4" onPress={() => onSubmit(newSubtotal)}>
            Continuar
          </FormButton>
          <FormButton
            colorScheme="white"
            textColor="primary.700"
            my="4"
            shadow="2"
            onPress={onClose}>
            Escolher outra data
          </FormButton>
        </VStack>
      }
    />
  );
};

export default OutdatedPromoPricesModal;
